var map = {
	"./Admin/Calculation/Create": 4515,
	"./Admin/Calculation/Create.js": 4515,
	"./Admin/Calculation/Index": 192,
	"./Admin/Calculation/Index.js": 192,
	"./Admin/Calculation/View": 6870,
	"./Admin/Calculation/View.js": 6870,
	"./Admin/Fond/Create": 9798,
	"./Admin/Fond/Create.js": 9798,
	"./Admin/Fond/Index": 6121,
	"./Admin/Fond/Index.jsx": 6121,
	"./Admin/InsuranceCompany/Create": 4045,
	"./Admin/InsuranceCompany/Create.js": 4045,
	"./Admin/InsuranceCompany/Edit": 718,
	"./Admin/InsuranceCompany/Edit.js": 718,
	"./Admin/InsuranceCompany/Index": 8480,
	"./Admin/InsuranceCompany/Index.js": 8480,
	"./Admin/Key/Create": 7290,
	"./Admin/Key/Create.js": 7290,
	"./Admin/Key/Edit": 4306,
	"./Admin/Key/Edit.js": 4306,
	"./Admin/Key/Index": 2279,
	"./Admin/Key/Index.js": 2279,
	"./Admin/Licence/Create": 6197,
	"./Admin/Licence/Create.js": 6197,
	"./Admin/Licence/Edit": 1098,
	"./Admin/Licence/Edit.js": 1098,
	"./Admin/Licence/Index": 5515,
	"./Admin/Licence/Index.js": 5515,
	"./Admin/Role/Create": 7631,
	"./Admin/Role/Create.js": 7631,
	"./Admin/Role/Edit": 1569,
	"./Admin/Role/Edit.js": 1569,
	"./Admin/Role/Index": 3308,
	"./Admin/Role/Index.js": 3308,
	"./Admin/User/Create": 5985,
	"./Admin/User/Create.js": 5985,
	"./Admin/User/Edit": 4947,
	"./Admin/User/Edit.js": 4947,
	"./Admin/User/Index": 1874,
	"./Admin/User/Index.js": 1874,
	"./Archive/Index": 2773,
	"./Archive/Index.jsx": 2773,
	"./Auth/ForgotPassword": 5544,
	"./Auth/ForgotPassword.js": 5544,
	"./Auth/Login": 1745,
	"./Auth/Login.js": 1745,
	"./Auth/Register": 5189,
	"./Auth/Register.jsx": 5189,
	"./Auth/ResetPassword": 6152,
	"./Auth/ResetPassword.js": 6152,
	"./Portfolio/AVV": 5781,
	"./Portfolio/AVV.jsx": 5781,
	"./Portfolio/AllocationUpdate": 5652,
	"./Portfolio/AllocationUpdate.jsx": 5652,
	"./Portfolio/Comparison": 1706,
	"./Portfolio/Comparison.jsx": 1706,
	"./Portfolio/Components/UploadComponent": 3440,
	"./Portfolio/Components/UploadComponent.jsx": 3440,
	"./Portfolio/Components/UploadOCRComponent": 7376,
	"./Portfolio/Components/UploadOCRComponent.jsx": 7376,
	"./Portfolio/Datenschutz": 9133,
	"./Portfolio/Datenschutz.jsx": 9133,
	"./Portfolio/ESGProfiling": 2742,
	"./Portfolio/ESGProfiling.jsx": 2742,
	"./Portfolio/ESGProfilingScreenFour": 3228,
	"./Portfolio/ESGProfilingScreenFour.jsx": 3228,
	"./Portfolio/ESGProfilingScreenThree": 9463,
	"./Portfolio/ESGProfilingScreenThree.jsx": 9463,
	"./Portfolio/ESGProfilingScreenTwo": 9210,
	"./Portfolio/ESGProfilingScreenTwo.jsx": 9210,
	"./Portfolio/ETF": 5406,
	"./Portfolio/ETF.jsx": 5406,
	"./Portfolio/ErgebnisESG": 9633,
	"./Portfolio/ErgebnisESG.jsx": 9633,
	"./Portfolio/ErgebnisOptimizeExisting": 6209,
	"./Portfolio/ErgebnisOptimizeExisting.jsx": 6209,
	"./Portfolio/ErgebnisRisiko": 8978,
	"./Portfolio/ErgebnisRisiko.jsx": 8978,
	"./Portfolio/FastLane": 6340,
	"./Portfolio/FastLane.jsx": 6340,
	"./Portfolio/FondsInfo": 793,
	"./Portfolio/FondsInfo.jsx": 793,
	"./Portfolio/Impressum": 5575,
	"./Portfolio/Impressum.jsx": 5575,
	"./Portfolio/Index": 157,
	"./Portfolio/Index.jsx": 157,
	"./Portfolio/InvestmentInfo": 4871,
	"./Portfolio/InvestmentInfo.jsx": 4871,
	"./Portfolio/Nutzungsbedingungen": 4170,
	"./Portfolio/Nutzungsbedingungen.jsx": 4170,
	"./Portfolio/OptimizeExisting": 648,
	"./Portfolio/OptimizeExisting.jsx": 648,
	"./Portfolio/Portfoliovorschlag": 1203,
	"./Portfolio/Portfoliovorschlag.jsx": 1203,
	"./Portfolio/RisikoProfiling": 7640,
	"./Portfolio/RisikoProfiling.jsx": 7640,
	"./Portfolio/VersichererInfo": 5324,
	"./Portfolio/VersichererInfo.jsx": 5324,
	"./Portfolio/Vertragsdetails": 5963,
	"./Portfolio/Vertragsdetails.jsx": 5963,
	"./Portfolio/Warning": 2332,
	"./Portfolio/Warning.jsx": 2332,
	"./Portfolio/Zusammenfassung": 3417,
	"./Portfolio/Zusammenfassung.jsx": 3417,
	"./User/Profile": 387,
	"./User/Profile.js": 387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;